import React, { useEffect } from 'react';

import { useLocation } from 'react-router';

import { IScrollToTop } from '../types/IScrollToTop';

const ScrollToTop: React.FC<IScrollToTop> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <>{children}</>;
};

export default ScrollToTop;